import { create } from 'zustand';

type AppLoaderStore = {
  loading: boolean;
  setLoading: (isloading: boolean) => void;
};

export const useAppLoaderStore = create<AppLoaderStore>((set) => ({
  loading: true,
  setLoading: (isloading: boolean) => set({ loading: isloading }),
}));
